import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PurchaseInvoiceRegisterForm from '../components/PurchaseInvoiceRegisterForm';
import { useGetPurchaseInvoiceRegisterHandler } from '../dataHandlers/getPurchaseInvoiceRegisterHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function PurchaseInvoiceRegisterDetailsPage() {
  const { purchaseInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(purchaseInvoiceRegister?.pages?.details_title ?? 'Purchase Invoice Register Details');
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { register, isLoading } = useGetPurchaseInvoiceRegisterHandler(document_id);

  useEffect(() => {
    if (!isLoading && register?.document_mode === 'E_INVOICE') {
      const documentId = register.uuid || register.id;
      navigate(`/purchases/documents/invoices/${documentId}`, { replace: true });
    }
  }, [isLoading, register, navigate]);

  if (isLoading || !register) {
    return <DocumentSkeletonForm />;
  }

  if (register.document_mode === 'E_INVOICE') {
    return <DocumentSkeletonForm />;
  }

  const onClickingBackButton = () => navigate('/purchase-invoice-register');

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <PurchaseInvoiceRegisterForm
        onSubmit={() => {}}
        onCancel={onClickingBackButton}
        initialData={register}
        readOnly
      />
    </Stack>
  );
}
